import React from 'react';
import { Navigate } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';

/**
 * SecureRoute component that verifies authentication before rendering children
 * This component uses the useOktaAuth hook from @okta/okta-react
 */
const SecureRoute = ({ children }) => {
  const { oktaAuth, authState } = useOktaAuth();

  // Save the current URL to redirect back after login
  React.useEffect(() => {
    if (!authState?.isAuthenticated) {
      // Save the current path for redirect after login
      localStorage.setItem('okta-app-original-uri', window.location.pathname);
    }
  }, [authState]);

  // Still loading auth state
  if (!authState) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-gray-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Verifying authentication...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!authState.isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // User is authenticated, render the protected component
  return children;
};

export default SecureRoute;
